import { Button } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Menu, MenuProps } from './Menu';
import { ScheduleReportButton } from './ScheduleReportButton';

export interface SavedViewControlsProps extends MenuProps {
  onSaveAsView: () => void;
  /** Holds Save As View while the grid saves the layout the new view copies. */
  saving?: boolean;
  onScheduleReport?: () => void;
}

/** A grid's saved-view controls for its tab row: My Views, Save As View and, where offered, Schedule Report. */
export const SavedViewControls = ({
  onSaveAsView,
  saving = false,
  onScheduleReport,
  ...menuProps
}: SavedViewControlsProps) => (
  <>
    <div
      className={`flex ${menuProps.selectedCustomView ? 'border-b-2 border-indigo' : ''}`}
      data-testid="saved-views-picker">
      <div className="self-center">
        <Menu {...menuProps} />
      </div>
    </div>
    <div className="ml-3 self-center">
      <Button
        onClick={onSaveAsView}
        disabled={saving}
        startIcon={<AddCircleIcon />}
        sx={{ fontSize: '.8rem', textTransform: 'none' }}>
        Save As View
      </Button>
    </div>
    {onScheduleReport && (
      <div className="ml-3 self-center">
        <ScheduleReportButton onClick={onScheduleReport} />
      </div>
    )}
  </>
);
